<template>
  <div class="ny">
    <div class="main">
      <div class="ny_bt1 mh md20">
        <span class="bt left">查看救助申请</span>
      </div>
      <!-- 审批状态 -->
      <div class="mh md20 spzt_k">
        <span class="s1">审批状态：</span>
        <span class="s2" :class="spData.Status >= 1 ? 'active' : ''"
          ><font>1.提交申请</font></span
        >
        <span class="s2" :class="spData.Status >= 2 ? 'active' : ''"
          ><font>2.主治医生审批</font></span
        >
        <span class="s2" :class="spData.Status >= 3 ? 'active' : ''"
          ><font>3.专家医生审批</font></span
        >
        <span class="s2" :class="spData.Status >= 4 ? 'active' : ''"
          ><font>4.基金会审批</font></span
        >
        <span class="s2" :class="spData.Status >= 5 ? 'active' : ''"
          ><font>5.申请完成</font></span
        >
      </div>
      <!-- 救助申请表信息 -->
      <div class="ny_xbt1 mh md15">
        <span class="bt left">亲体移植受者申请表信息</span>
      </div>
      <ul class="jzform_list">
        <li>
          <span class="s_name">受者姓名：</span>
          <p>{{ spData.PatientName }}</p>
        </li>
        <li>
          <span class="s_name">性别：</span>
          <p>{{ spData.Gender }}</p>
        </li>
        <li>
          <span class="s_name">出生日期：</span>
          <p>{{ spData.Birthday }}</p>
        </li>
        <li>
          <span class="s_name">年龄：</span>
          <p>{{ spData.Age }}</p>
        </li>
        <li>
          <span class="s_name">移植选项：</span>
          <p>{{ spData.TransplantType === 1 ? "亲体肝脏移植" : spData.TransplantType === 2 ? "亲体肾脏移植" : "其他 —— " + spData.TransplantContent}}</p>
          <p></p>
        </li>

        <li>
          <span class="s_name">病情简述：</span>
          <p>{{ spData.Illness }}</p>
        </li>
        <li>
          <span class="s_name">联系人：</span>
          <p>{{ spData.Contacts }}</p>
        </li>
        <li>
          <span class="s_name">医保类型：</span>
          <p>{{ spData.InsuranceCategory }}</p>
        </li>
        <li>
          <span class="s_name">联系电话：</span>
          <p>{{ spData.ContactsPhone }}</p>
        </li>
        <li>
          <span class="s_name">通信地址：</span>
          <p>
            {{ spData.Province }} {{ spData.City }} {{ spData.District }}
            {{ spData.Address }}
          </p>
        </li>
        <li>
          <span class="s_name">邮箱地址：</span>
          <p>{{ spData.Email }}</p>
        </li>
        <li>
          <span class="s_name">身份证号码：</span>
          <p>{{ spData.IdentityCard }}</p>
        </li>
        <li>
          <span class="s_name">主治医生：</span>
          <p>{{ spData.DoctorName }}</p>
        </li>
        <li>
          <span class="s_name">户口所在地：</span>
          <p>
          <p>{{ spData.HouseholdProvince }} {{ spData.HouseholdCity }}</p>
        </li>
      </ul>
      <!--受者照片-->
      <div class="ny_xbt1 mh md15">
        <span class="bt left">亲体移植受者照片</span>
      </div>
      <div class="hzpic_list mh md30">
        <el-image 
        v-for="url in hzpic" 
        :key="url" 
        :src="url" 
        lazy
        :preview-src-list="hzpic"
        ></el-image>
      </div>
      <!--亲体移植供者申请信息-->
      <div class="ny_xbt1 mh md15">
        <span class="bt left">亲体移植供者申请信息</span>
      </div>
      <ul class="jzform_list">
        <li>
          <span class="s_name">供者姓名：</span>
          <p>{{ spData.ProviderName }}</p>
        </li>
        <li>
          <span class="s_name">性别：</span>
          <p>{{ spData.ProviderGender }}</p>
        </li>
        <li>
          <span class="s_name">出生日期：</span>
          <p>{{ spData.ProviderBirthday }}</p>
        </li>
        <li>
          <span class="s_name">年龄：</span>
          <p>{{ spData.ProviderAge }}</p>
        </li>
        <li>
          <span class="s_name">供者身份证号码：</span>
          <p>{{ spData.ProviderIdCard }}</p>
        </li>
        <li>
          <span class="s_name">医保类型：</span>
          <p>{{ spData.ProviderInsuranceCategory }}</p>
        </li>
        <li>
          <span class="s_name">联系人：</span>
          <p>{{ spData.ProviderContacts }}</p>
        </li>
        <li>
          <span class="s_name">与受者关系：</span>
          <p>{{ spData.ProviderRelation }}</p>
        </li>
        <li>
          <span class="s_name">联系电话：</span>
          <p>{{ spData.ProviderContactsPhone }}</p>
        </li>
        <li>
          <span class="s_name">通信地址：</span>
          <p>
            {{ spData.ProviderProvince }} {{ spData.ProviderCity }} {{ spData.ProviderDistrict }}
            {{ spData.ProviderAddress }}
          </p>
        </li>
        <li>
          <span class="s_name">邮箱地址：</span>
          <p>{{ spData.ProviderEmail }}</p>
        </li>

      </ul>
      <!--供者照片-->
      <div class="ny_xbt1 mh md15">
        <span class="bt left">亲体移植供者照片</span>
      </div>
      <div class="hzpic_list mh md30">
        <el-image
          v-for="url in hzpic_gz"
          :key="url"
          :src="url"
          lazy
          :preview-src-list="hzpic_gz"
        ></el-image>
      </div>
      <!-- 家庭情况 -->
      <!--<div class="ny_xbt1 mh md20">-->
        <!--<span class="bt left">家庭情况（直系亲属）</span>-->
      <!--</div>-->
      <!--<div class="mh md20 ta_k">-->
        <!--<el-table :data="tableData" border style="width: 100%">-->
          <!--<el-table-column prop="RealName" label="姓名" width="200">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="Relation" label="关系" width="200">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="Age" label="年龄" width="200">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="Occupation" label="职业"> </el-table-column>-->
        <!--</el-table>-->
      <!--</div>-->
      <!--&lt;!&ndash; 是否亲体移植 &ndash;&gt;-->
      <!--<div class="ny_xbt1 mh md15">-->
        <!--<span class="bt left">是否亲体移植</span>-->
      <!--</div>-->
      <!--<ul class="jzform_list">-->
        <!--<li style="margin-bottom: 0">-->
          <!--<span class="s_name">是否亲体移植：</span>{{ spData.IsTransplant }}-->
        <!--</li>-->
      <!--</ul>-->
      <!--<div class="mh qtyz_lb" v-show="spData.IsTransplant == '是'">-->
        <!--<ul class="jzform_list">-->
          <!--<li>-->
            <!--<span class="s_name">姓名：</span>-->
            <!--<p>{{ spData.TransplantName }}</p>-->
          <!--</li>-->
          <!--<li>-->
            <!--<span class="s_name">性别：</span>-->
            <!--<p>{{ spData.TransplantGender }}</p>-->
          <!--</li>-->
          <!--<li>-->
            <!--<span class="s_name">关系：</span>-->
            <!--<p>{{ spData.TransplantRelation }}</p>-->
          <!--</li>-->
          <!--<li>-->
            <!--<span class="s_name">年龄：</span>-->
            <!--<p>{{ spData.TransplantAge }}</p>-->
          <!--</li>-->
        <!--</ul>-->
      <!--</div>-->
      <!--<div class="ny_xbt1 mh md20">-->
        <!--<span class="bt left">患者医疗情况简述</span>-->
      <!--</div>-->
      <!--<div class="mh md40">-->
        <!--{{ spData.MedicalConditions }}-->
      <!--</div>-->
      <!-- 附件上传 -->
      <div class="ny_xbt1 mh md20">
        <span class="bt left">上传附件资料</span>
      </div>
      <div class="mh  md20">
        <p class="md10">亲体移植受者身份证明（户口本和身份证）复印件：</p>
        <div class="hzpic_list mh ">
          <el-image 
          v-for="url in hkbpic" 
          :key="url" 
          :src="url" 
          lazy
          :preview-src-list="hkbpic"
          ></el-image>
      </div>
      
      </div>
      <div class="mh  md20">
        <p class="md10">亲体移植供者身份证明（户口本和身份证）复印件：</p>
        <div class="hzpic_list mh ">
          <el-image 
          v-for="url in jhrpic" 
          :key="url" 
          :src="url" 
          lazy
          :preview-src-list="jhrpic"
          ></el-image>
      </div>
      </div>
      <div class="mh md20">
        <p class="md10">
          亲体移植受者化验报告：血常规、肝（肾）功能、出凝血时间、疾病诊断证明（天津市第一中心医院门诊病历或住院病例首页）：
        </p>
        <div class="hzpic_list mh ">
          <el-image 
          v-for="url in jcbgpic" 
          :key="url" 
          :src="url" 
          lazy
          :preview-src-list="jcbgpic"
          ></el-image>
      </div>
      </div>
      <div class="mh md40">
        <p class="md10">亲体移植受者 B 超检查结果：</p>
       <div class="hzpic_list mh ">
          <el-image 
          v-for="url in bcpic" 
          :key="url" 
          :src="url" 
          lazy
          :preview-src-list="bcpic"
          ></el-image>
      </div>
      </div>
      <div class="suc_anq mh">
        <el-button type="primary" @click="$router.back(-1)"
          >返回上一步</el-button
        >
        <el-button type="info" @click="edit_sp()"
        v-show="spData.IsEdit > 0"
          >我要修改</el-button
        >
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import http from "../../http/http";
import api from "../../http/api";
export default {
  data() {
    return {
      spzt: 2,
      tableData: [],
      spData: [],
      hzpic: [],
      hzpic_gz: [],
      hkbpic:[],
      jhrpic:[],
      jcbgpic:[],
      bcpic:[],
    };
  },
  mounted() {
    //加载详细
    this.DetailData();
  },
  methods: {
     // 修改
      edit_sp() {
        this.$router.push({
          name: "edit_sp",
          query: {
            UserId: this.$route.query.UserId,
            ApplyId: this.$route.query.ApplyId,
          }
        });
      },
    //详细
    DetailData: async function () {
      let params = {
        UserId: this.$route.query.UserId,
        ApplyId: this.$route.query.ApplyId,
      };
      const res = await http.get(api.apigetdetail, params);
      this.spData = res.data.obj;
      // 受者
      if(res.data.obj.UserSaveNamePic != ""){
        this.hzpic = res.data.obj.UserSaveNamePic.split('|');
      }
      // 供者
      if(res.data.obj.DonorSaveNamePic != ""){
        this.hzpic_gz = res.data.obj.DonorSaveNamePic.split('|');
      }
      // 申请人
      this.hkbpic=res.data.obj.UserHouseholdSaveNamePic.split('|');
      // 监护人
      this.jhrpic=res.data.obj.ParentsHouseholdSaveNamePic.split('|');
      // 检查报告
      this.jcbgpic=res.data.obj.UserSerologicalSaveNamePic.split('|');
      // B超
      this.bcpic=res.data.obj.UserExaminationSaveNamePic.split('|');
      // 家庭情况
      this.tableData = res.data.obj.FamilieList;
      // console.log(this.spData);
    },
    //转化数组
  ipaddrArray() {
    var t1=this.spData.UserSaveNamePic;
    this.hzpic=this.spData.UserSaveNamePic;
    // console.log(this.spData.UserSaveNamePic);
    // console.log(this.spData);
  },
  },
  created: function () {
    // this.$emit('header', false);
  },
  
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/user/userspinfo.vue